<template>
  <div class="headquarter">
    <div
      v-if="hasTitle"
      class="headquarter__title"
    >
      <slot name="title" />
    </div>
    <p
      v-if="hasNameSlot"
      class="headquarter__name"
    >
      <slot name="name" />
    </p>
    <div class="headquarter__info">
      <slot name="items" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'headquarter-item',
  props: {
    hasTitle: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    hasNameSlot() {
      const slot = this.$slots.name
      const slotContent = slot ? slot() : []
      return slotContent.length > 0
    }
  }
}
</script>

<style scoped lang="scss">
.headquarter {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  &__title {
    @include font-telegraf(400);
    color: $neutral-01;
    font-size: 1.25rem;
    line-height: 1.75rem;
    text-align: left;
  }

  &__name {
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.3125rem;
    letter-spacing: -0.01em;
    margin-bottom: 0.5rem;
    text-align: left;
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
}
</style>
